import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clouds-deco',
  templateUrl: './clouds-deco.component.html',
  styleUrls: ['./clouds-deco.component.scss']
})
export class CloudsDecoComponent {
  constructor() { }
}
